module.exports = __webpack_public_path__ + "02_short_beige.93634b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_short_beige.png
// module id = 7nSK
// module chunks = 0